<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <span class='icon back' @click='$router.back()'><i class='fas fa-arrow-left' aria-hidden='true'></i></span>
                <h3>{{ schoolName }} / {{ yearName }} / 行事一覧</h3>
                <button class='right-block button is-info' @click='changeActive("isActive")'>新規追加</button>
            </div>
            <ul v-if='schoolMap[schoolId] && schoolMap[schoolId].years[yearId].events' class='list'>
                <li v-for="(event, key) in schoolMap[schoolId].years[yearId].events" :key="key" :value="key" class='list-item'>
                    <input type='text' :id='`enabled-${key}`' :value='event.name' @change='edit(key)' disabled>
                    <div class='right-block'>
                        <span class='icon' @click='enabled(key)'><i class='fas fa-pen' aria-hidden='true'></i></span>
                        <span class='icon' @click='trash(key)'><i class='fas fa-trash' aria-hidden='true'></i></span>
                    </div>
                </li>
            </ul>

            <div class='block'>
                <div class='content-header'>
                    <h3 class='h3'>クラス管理</h3>
                    <button class='right-block button is-info' @click='changeActive("classIsActive")'>新規追加</button>
                </div>
                <ul v-if='schoolMap[schoolId] && schoolMap[schoolId].years[yearId].classes' class='list'>
                    <li v-for="(schoolClass, key) in schoolMap[schoolId].years[yearId].classes" :key="key" :value="key" class='list-item'>
                        <input type='text' :id='`enabled-class-${key}`' :value='schoolClass.name' @change='editClass(key)' disabled>
                        <div class='right-block'>
                            <span class='icon' @click='enabledClass(key)'><i class='fas fa-pen' aria-hidden='true'></i></span>
                            <span class='icon' @click='trashClass(key)'><i class='fas fa-trash' aria-hidden='true'></i></span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="modal" :class="{ 'is-active': isActive }">
            <div class="modal-background" @click='changeActive("isActive")'></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">行事新規追加</p>
                    <button class="delete" aria-label="close" @click='changeActive("isActive")'></button>
                </header>
                <section class="modal-card-body">
                    <input class="input" type="text" v-model='eventName' placeholder="行事名">
                </section>
                <footer class="modal-card-foot">
                    <div class='right-block'>
                        <button class="button is-info" @click='add'>送信</button>
                        <button class="button" @click='changeActive("isActive")'>閉じる</button>
                    </div>
                </footer>
            </div>
            <button class="modal-close is-large" aria-label="close" @click='changeActive("isActive")'></button>
        </div>

        <div class="modal" :class="{ 'is-active': classIsActive }">
            <div class="modal-background" @click='changeActive("classIsActive")'></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">クラス新規追加</p>
                    <button class="delete" aria-label="close" @click='changeActive("classIsActive")'></button>
                </header>
                <section class="modal-card-body">
                    <input class="input" type="text" v-model='className' placeholder="クラス名">
                </section>
                <footer class="modal-card-foot">
                    <div class='right-block'>
                        <button class="button is-info" @click='addClass'>送信</button>
                        <button class="button" @click='changeActive("classIsActive")'>閉じる</button>
                    </div>
                </footer>
            </div>
            <button class="modal-close is-large" aria-label="close" @click='changeActive("classIsActive")'></button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'School',
    props: ['schoolMap'],
    components: {
    },
    data () {
        return {
            setting: false,
            upload: true,
            isActive: false,
            classIsActive: false,
            schoolName: '',
            yearName: '',
            eventName: '',
            className: '',
            schoolId: null,
            yearId: null
        }
    },
    mounted () {
        this.schoolId = this.$route.params.schoolId
        this.yearId = this.$route.params.yearId
        if (this.schoolMap[this.schoolId]) {
            this.schoolName = this.schoolMap[this.schoolId].name
            if (this.schoolMap[this.schoolId].years[this.yearId]) {
                this.yearName = this.schoolMap[this.schoolId].years[this.yearId].name
            }
        }
    },
    watch: {
        schoolMap: {
            handler () {
                if (this.schoolMap[this.schoolId]) {
                    this.schoolName = this.schoolMap[this.schoolId].name
                    if (this.schoolMap[this.schoolId].years[this.yearId]) {
                        this.yearName = this.schoolMap[this.schoolId].years[this.yearId].name
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        changeActive (param) {
            this[param] = !this[param]
        },
        trash (key) {
            if (window.confirm('削除した行事にアップロードされた全ての写真は削除されますがよろしいですか？')) {
                this.axios.delete(`${process.env.API_URL}/photographer/event/${key}`).then((res) => {
                    location.reload()
                }).catch((e) => {
                    alert('サーバーエラーが発生しました')
                })
            }
        },
        trashClass (key) {
            this.axios.delete(`${process.env.API_URL}/photographer/class/${key}`).then((res) => {
                location.reload()
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        edit (key, e) {
            document.getElementById(`enabled-${key}`).disabled = true
            this.axios.put(`${process.env.API_URL}/photographer/event`, {
                id: key,
                name: document.getElementById(`enabled-${key}`).value
            }).then((res) => {
                console.log(res)
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        editClass (key, e) {
            document.getElementById(`enabled-class-${key}`).disabled = true
            this.axios.put(`${process.env.API_URL}/photographer/class`, {
                id: key,
                name: document.getElementById(`enabled-class-${key}`).value
            }).then((res) => {
                console.log(res)
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        add () {
            const params = this.$parent.requestParams
            this.axios.post(`${process.env.API_URL}/photographer/event${params}`, {
                name: this.eventName,
                school_id: this.schoolId,
                year_id: this.yearId
            }).then((res) => {
                location.reload()
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        addClass () {
            const params = this.$parent.requestParams
            this.axios.post(`${process.env.API_URL}/photographer/class${params}`, {
                name: this.className,
                school_id: this.schoolId,
                year_id: this.yearId
            }).then((res) => {
                location.reload()
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        enabled (key) {
            document.getElementById(`enabled-${key}`).disabled = !document.getElementById(`enabled-${key}`).disabled
        },
        enabledClass (key) {
            document.getElementById(`enabled-class-${key}`).disabled = !document.getElementById(`enabled-class-${key}`).disabled
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}
.content {
    margin: auto;
    padding: 25px;
    width: 780px;
}

.block {
    margin-top: 100px;
}

.list {
}

.list-item {
    height: 48px;
    padding: 4px 12px;
    list-style: none;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}

.list-item input {
    height: 40px;
    font-size: 18px;
    line-height: 40px;
    padding: 0 8px;
}

.list-item input:disabled {
    background: white;
    border: none;
    height: 40px;
    font-size: 18px;
    pointer-events: none;
}

.right-block {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.icon {
    cursor: pointer;
    font-size: 22px;
    padding: 8px 10px;
}

.icon + .icon {
    margin-left: 10px;
}

.content-header {
    display: flex;
    padding-bottom: 20px;
}

.content-header h3 {
    line-height: 40px;
    margin: 0;
}

.back {
    height: 40px;
    width: 40px;
}

h3 {
    line-height: 40px;
}

.h3 {
    margin-left: 40px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/photographer/pages/Event.vue